/* ==============================================================================
   LG SHIPPING BAR — Lógica reactiva y unificada (PDP)
   ============================================================================== */
(function () {
  'use strict';

  let lastCartTotal = null;
  let debounceTimeout1 = null;
  let debounceTimeout2 = null;

  function formatMoney(cents) {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  // Actualizar todos los elementos de barra de progreso activos en el DOM
  function updateProgressBar(container, cartData) {
    const bar = container.querySelector('.lg-cartbar__fill') || container.querySelector('.lg-shipping-bar-fill') || container.querySelector('.lg-shipping-bar__fill');
    const statusText = container.querySelector('.lg-cartbar__status') || container.querySelector('.js-lg-status');
    const hintContainer = container.querySelector('.lg-cartbar__hint');
    const cartBarContainer = container.classList.contains('lg-cartbar') ? container : container.querySelector('.lg-cartbar');
    
    if (!bar || !statusText) return;

    const limit = parseInt(container.dataset.limit || (cartBarContainer ? cartBarContainer.dataset.limit : null) || '10000', 10);
    const total = cartData.total_price;

    let percent = (total / limit) * 100;
    if (percent > 100) percent = 100;

    bar.style.setProperty('width', percent + '%', 'important');

    const missing = limit - total;
    if (missing <= 0) {
      statusText.innerHTML = '¡Conseguido!';
      if (cartBarContainer) cartBarContainer.classList.add('lg-cartbar--done');
      bar.classList.add('lg-shipping-bar__fill--complete');
      if (hintContainer) {
        hintContainer.className = 'lg-cartbar__hint lg-cartbar__hint--done';
        hintContainer.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg> Tu pedido califica para envío gratuito.';
      }
    } else {
      statusText.innerText = 'Faltan ' + formatMoney(missing);
      if (cartBarContainer) cartBarContainer.classList.remove('lg-cartbar--done');
      bar.classList.remove('lg-shipping-bar__fill--complete');
      if (hintContainer) {
        hintContainer.className = 'lg-cartbar__hint';
        hintContainer.innerHTML = 'Añade <b>' + formatMoney(missing) + '</b> más y consigue <b>envío gratuito</b>.';
      }
    }
  }

  // --- Envío gratis en el PDP contando ESTE producto ---
  // total = carrito actual + precio de la variante seleccionada × cantidad.
  function getPdpQuantity() {
    const input = document.querySelector('.product-form__quantity .quantity__input');
    const qty = input ? parseInt(input.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  function updatePdpFreeship(cartTotal) {
    if (typeof cartTotal !== 'number') return;
    document.querySelectorAll('.lg-pdp-freeship').forEach(function (el) {
      const limit = parseInt(el.dataset.limit, 10) || 10000;
      const price = parseInt(el.dataset.productPrice, 10) || 0;
      const total = cartTotal + price * getPdpQuantity();
      const missing = limit - total;
      const percent = Math.min(100, Math.round((total / limit) * 100));
      const text = el.querySelector('.lg-pdp-freeship__text');
      const fill = el.querySelector('.lg-pdp-freeship__fill');

      el.classList.toggle('is-free', missing <= 0);
      if (fill) fill.style.setProperty('width', percent + '%');
      if (!text) return;
      if (missing <= 0) {
        text.innerHTML = cartTotal >= limit
          ? 'Ya tienes <b>envío gratis</b> en tu pedido'
          : 'Con este producto tu envío es <b>gratis</b>';
      } else {
        text.innerHTML = 'Añádelo y te faltarán <b>' + formatMoney(missing) + '</b> para el envío gratis';
      }
    });
  }

  // Cambios de cantidad en el formulario del producto
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-form__quantity')) {
      updatePdpFreeship(lastCartTotal);
    }
  });

  async function fetchCart() {
    try {
      const rootUrl =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
        (window.routes && window.routes.cart_url ? window.routes.cart_url.replace(/cart$/, '') : '/');
      const res = await fetch(rootUrl + 'cart.js?t=' + Date.now());
      if (!res.ok) return;
      const data = await res.json();
      lastCartTotal = data.total_price;
      updatePdpFreeship(lastCartTotal);
      
      // Consultar dinámicamente cada vez para evitar elementos obsoletos (stale elements)
      const activeContainers = document.querySelectorAll('.lg-shipping-bar, .lg-cartbar');
      activeContainers.forEach((container) => updateProgressBar(container, data));
    } catch (err) {
      console.log('Error al consultar el carrito de Shopify:', err);
    }
  }

  // Doble disparo para latencia de Shopify
  function triggerCartRefresh() {
    if (debounceTimeout1) clearTimeout(debounceTimeout1);
    if (debounceTimeout2) clearTimeout(debounceTimeout2);

    const totalBefore = lastCartTotal;
    debounceTimeout1 = setTimeout(fetchCart, 150);
    debounceTimeout2 = setTimeout(function () {
      if (lastCartTotal === totalBefore) fetchCart();
    }, 750);
  }

  // 1. Interceptar FETCH
  if (!window.lgFetchIntercepted) {
    window.lgFetchIntercepted = true;
    const originalFetch = window.fetch;
    window.fetch = async function () {
      const response = await originalFetch.apply(this, arguments);
      try {
        const arg0 = arguments[0];
        const url = typeof arg0 === 'string' ? arg0 : (arg0 && arg0.url ? arg0.url : '');
        if (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear') ||
          url.includes('/cart?sections=')
        ) {
          triggerCartRefresh();
        }
      } catch (e) {
        // Silencioso
      }
      return response;
    };
  }

  // 2. Interceptar XHR
  if (!window.lgXhrIntercepted) {
    window.lgXhrIntercepted = true;
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener('load', function () {
        try {
          if (
            url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update') ||
            url.includes('/cart/clear')
          ) {
            triggerCartRefresh();
          }
        } catch (e) {
          // Silencioso
        }
      });
      return originalOpen.apply(this, arguments);
    };
  }

  // 3. Pub/Sub de Dawn para actualizaciones de carrito
  function initCartPubSub(attempt) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, triggerCartRefresh);
    } else if ((attempt || 0) < 50) {
      setTimeout(function () { initCartPubSub((attempt || 0) + 1); }, 100);
    }
  }

  // --- Delegación de eventos para copiar SKU (resistente a re-renders) ---
  document.addEventListener('click', function (e) {
    const skuEl = e.target.closest('.lg-shipping-bar__sku');
    if (!skuEl || !skuEl.dataset.sku) return;
    if (skuEl.classList.contains('lg-shipping-bar__sku--copied')) return;
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(skuEl.dataset.sku).then(function () {
      skuEl.classList.add('lg-shipping-bar__sku--copied');
      setTimeout(function () {
        skuEl.classList.remove('lg-shipping-bar__sku--copied');
      }, 2000);
    }).catch(function () {});
  });

  // --- Countdown del ciclo de preparación ---
  // La hora de corte llega del ajuste del tema vía data-cutoff-hour: el texto
  // promete "entrar en preparación", no "envío hoy", para no contradecir los
  // días de preparación configurados.
  function initUrgency(container) {
    const urgencyEl = container.querySelector('.js-lg-urgency');
    if (!urgencyEl) return;

    const cutoffHour = parseInt(container.dataset.cutoffHour, 10) || 13;

    function updateUrgency() {
      const now = new Date();
      const cutoff = new Date();
      cutoff.setHours(cutoffHour, 0, 0, 0);

      const day = now.getDay();
      if (day === 6 || day === 0 || (day === 5 && now >= cutoff)) {
        urgencyEl.innerText = 'Próximo ciclo de preparación: Lunes';
      } else if (now >= cutoff) {
        const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        urgencyEl.innerText = 'Próximo ciclo de preparación: ' + dayNames[day + 1];
      } else {
        const diff = cutoff - now;
        const h = Math.floor(diff / 3.6e6);
        const m = Math.floor((diff % 3.6e6) / 6e4);
        urgencyEl.innerHTML = 'Pide en <b>' + h + 'h ' + m + 'm</b> y tu pedido entra hoy en preparación';
      }
    }

    updateUrgency();
    if (window.lgUrgencyInterval) clearInterval(window.lgUrgencyInterval);
    window.lgUrgencyInterval = setInterval(updateUrgency, 60000);
  }

  // --- Estimación de fecha de entrega ---
  // Rango = inicio del ciclo + (preparación + demora proveedor + transporte)
  // en días laborables, con todos los valores llegando de los ajustes del
  // tema vía data-attributes. Misma fuente que el countdown y el desglose.
  function initDeliveryDate(container) {
    const dateEl = container.querySelector('.js-lg-date');
    if (!dateEl) return;

    const cutoffHour = parseInt(container.dataset.cutoffHour, 10) || 13;
    const prepMin = parseInt(container.dataset.prepMin, 10) || 0;
    const prepMax = parseInt(container.dataset.prepMax, 10) || 0;
    const transportMin = parseInt(container.dataset.transportMin, 10) || 1;
    const transportMax = parseInt(container.dataset.transportMax, 10) || 1;
    const vendorDelay = parseInt(container.dataset.vendorDelay, 10) || 0;

    function addWorkingDays(date, days) {
      const result = new Date(date);
      let added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        if (result.getDay() !== 0 && result.getDay() !== 6) added++;
      }
      return result;
    }

    function getDeliveryDate() {
      const now = new Date();
      const shipDate = new Date(now);
      if (now.getHours() >= cutoffHour) shipDate.setDate(shipDate.getDate() + 1);
      while (shipDate.getDay() === 0 || shipDate.getDay() === 6) {
        shipDate.setDate(shipDate.getDate() + 1);
      }
      const start = addWorkingDays(shipDate, prepMin + vendorDelay + transportMin);
      const end = addWorkingDays(shipDate, prepMax + vendorDelay + transportMax);

      const opts = { weekday: 'short', day: 'numeric', month: 'short' };
      const format = function (date) {
        const str = date.toLocaleDateString('es-ES', opts);
        return str.charAt(0).toUpperCase() + str.slice(1);
      };
      return format(start) + ' - ' + format(end);
    }

    dateEl.innerText = getDeliveryDate();
  }

  // Inicializar widgets dinámicos en los contenedores activos
  function initProductWidgets() {
    const activeContainers = document.querySelectorAll('.lg-shipping-bar');
    activeContainers.forEach(function (container) {
      initUrgency(container);
      initDeliveryDate(container);
    });
  }

  // Combinación inexistente: Dawn no publica variantChange (solo oculta el precio y deja «No disponible»).
  // Al detectar el precio oculto se retiran la entrega, el envío gratis y el «Avísame»; al elegir una combinación
  // válida, variantChange vuelve a mostrarlos según su disponibilidad.
  function watchUnavailableCombination() {
    const info = document.querySelector('product-info');
    const price = info && info.querySelector('[id^="price-"]');
    if (!price || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      if (!price.classList.contains('hidden')) return;
      document.querySelectorAll('.lg-shipping-bar__shipping').forEach(function (el) { el.style.display = 'none'; });
      document.querySelectorAll('[data-lg-backinstock]').forEach(function (el) { el.style.display = 'none'; });
      document.querySelectorAll('[data-lg-gallery-badges]').forEach(function (el) { el.replaceChildren(); });
    }).observe(price, { attributes: true, attributeFilter: ['class'] });
  }
  watchUnavailableCombination();

  // 4. Suscribirse a variantChange de Dawn para actualizar dinámicamente el SKU y visibilidad
  function initVariantPubSub(attempt) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        // Dawn publica { data: { variant, sectionId, html } }
        const variant = event && event.data && event.data.variant;
        if (!variant) return;
        
        // Re-inicializar widgets y recalcular fechas/urgencia al cambiar de variante
        setTimeout(initProductWidgets, 50);

        // Insignias de la foto principal (agotado, descuento, envío gratis) según la nueva variante; «Solo N ud» se retira (el stock exacto no viaja en el evento)
        document.querySelectorAll('[data-lg-gallery-badges]').forEach(function (box) {
          const make = function (cls, text) {
            const span = document.createElement('span');
            span.className = 'badge ' + cls;
            span.textContent = text;
            return span;
          };
          const badges = [];
          if (variant.available === false) {
            badges.push(make('lg-badge-sold-out', box.dataset.soldOutLabel || 'Agotado'));
          } else if (variant.compare_at_price > variant.price) {
            badges.push(make('lg-badge-sale', '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%'));
          }
          if (variant.available !== false && variant.price >= 10000) badges.push(make('lg-free-shipping-badge', 'Envío gratis'));
          box.replaceChildren.apply(box, badges);
        });

        // Texto de envío bajo el precio (cruza o no los 100 € según la variante)
        document.querySelectorAll('[data-lg-ship-text]').forEach(function (el) {
          if (typeof variant.price !== 'number') return;
          el.textContent = variant.price >= 10000
            ? 'Envío gratis a península.'
            : 'Envío a península desde ' + (el.dataset.rate || '7,99') + '\u00a0€, gratis desde 100\u00a0€.';
        });

        // Favoritos y Comparar de la ficha: guardan la VARIANTE elegida (título, precio, imagen y enlace)
        document.querySelectorAll('.lg-actions-row .lg-compare-btn-toggle, .lg-actions-row .lg-wishlist-btn-toggle').forEach(function (btn) {
          const d = btn.dataset;
          if (!d.baseTitle || !variant.id) return;
          d.variantId = variant.id;
          d.title = variant.title && variant.title !== 'Default Title' ? d.baseTitle + ' — ' + variant.title : d.baseTitle;
          if (d.baseUrl) d.url = d.baseUrl + '?variant=' + variant.id;
          if (typeof variant.price === 'number') d.price = formatMoney(variant.price);
          const vsrc = variant.featured_image && variant.featured_image.src;
          if (vsrc) d.image = vsrc.replace(/(\.[a-z]+)(\?|$)/i, '_150x$1$2');
        });

        // Barra fija móvil: miniatura y nombre de la variante elegida
        document.querySelectorAll('lg-sticky-atc').forEach(function (bar) {
          const title = bar.querySelector('.lg-sticky-atc__title');
          if (title) {
            if (!title.dataset.base) title.dataset.base = title.textContent.trim();
            title.textContent = variant.title && variant.title !== 'Default Title'
              ? title.dataset.base + ' — ' + variant.title
              : title.dataset.base;
          }
          const img = bar.querySelector('.lg-sticky-atc__img');
          const src = variant.featured_image && variant.featured_image.src;
          if (img && src) {
            img.removeAttribute('srcset');
            img.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
          }
        });

        // Envío gratis con el precio de la nueva variante
        document.querySelectorAll('.lg-pdp-freeship').forEach(function (el) {
          if (typeof variant.price === 'number') el.dataset.productPrice = variant.price;
        });
        updatePdpFreeship(lastCartTotal);

        // 1. Actualizar la referencia (SKU) allí donde se muestre: la línea de
        //    metadatos sobre el título (lg-pdp-meta) o cualquier otra instancia.
        document.querySelectorAll('.lg-shipping-bar__sku').forEach(function(skuEl) {
          const prefix = skuEl.dataset.prefix || 'SKU: ';
          const skuTextNode = skuEl.childNodes[0];
          if (skuTextNode && skuTextNode.nodeType === Node.TEXT_NODE) {
            skuTextNode.textContent = prefix + (variant.sku || '');
          } else {
            skuEl.insertBefore(document.createTextNode(prefix + (variant.sku || '')), skuEl.firstChild);
          }
          skuEl.dataset.sku = variant.sku || '';
          skuEl.style.visibility = variant.sku ? 'visible' : 'hidden';
        });

        const activeContainers = document.querySelectorAll('.lg-shipping-bar');
        activeContainers.forEach(function(container) {
          // 2. Controlar visibilidad según disponibilidad
          const shippingContent = container.querySelector('.lg-shipping-bar__shipping');
          if (shippingContent) {
            if (variant.available) {
              shippingContent.style.display = 'block';
            } else {
              shippingContent.style.display = 'none';
            }
          }
        });
      });
    } else if ((attempt || 0) < 50) {
      setTimeout(function () { initVariantPubSub((attempt || 0) + 1); }, 100);
    }
  }

  // Ejecución inicial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProductWidgets();
      fetchCart();
    });
  } else {
    initProductWidgets();
    fetchCart();
  }

  initCartPubSub(0);
  initVariantPubSub(0);
  document.addEventListener('shopify:section:load', function() {
    initProductWidgets();
    fetchCart();
  });
})();
